import { render, staticRenderFns } from "./office-record.vue?vue&type=template&id=54b296e8"
import script from "./office-record.vue?vue&type=script&lang=js"
export * from "./office-record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports